import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TrophyClub.css';
import april2025 from '../../assets/images/trophy-club/april-2025.png';
import may2025 from '../../assets/images/trophy-club/may-2025.png';
import june2025 from '../../assets/images/trophy-club/june-2025.png';
import july2025 from '../../assets/images/trophy-club/july-2025.png';
import august2025 from '../../assets/images/trophy-club/august-2025.png';
import september2025 from '../../assets/images/trophy-club/september-2025.png';
import october2025 from '../../assets/images/trophy-club/october-2025.png';
import november2025 from '../../assets/images/trophy-club/november-2025.png';
import december2025 from '../../assets/images/trophy-club/december-2025.png';
import january2026 from '../../assets/images/trophy-club/january-2026.png';
import february2026 from '../../assets/images/trophy-club/february-2026.png';
import march2026 from '../../assets/images/trophy-club/march-2026.png';
import april2026 from '../../assets/images/trophy-club/april-2026.png';
import may2026 from '../../assets/images/trophy-club/may-2026.png';
import june2026 from '../../assets/images/trophy-club/june-2026.png';
import july2026 from '../../assets/images/trophy-club/july-2026.png';
import august2026 from '../../assets/images/trophy-club/august-2026.png';
import { fetchTopDesignForMonth } from '../../utils/designStatsUtils';

const VOTE_NOW_MONTH = 9;
const VOTE_NOW_YEAR = 2026;

const TrophyClub = () => {
  const navigate = useNavigate();
  const [show2025, setShow2025] = useState(false);
  const [leadingDesign, setLeadingDesign] = useState(null);

  useEffect(() => {
    let active = true;

    const loadLeadingDesign = async () => {
      try {
        const septemberLeader = await fetchTopDesignForMonth(VOTE_NOW_YEAR, VOTE_NOW_MONTH);

        if (!active) {
          return;
        }

        setLeadingDesign(septemberLeader);
      } catch (error) {
        console.error('Failed to load Trophy Club leader data:', error);
      }
    };

    loadLeadingDesign();

    return () => {
      active = false;
    };
  }, []);

  const handleVoteNow = () => {
    navigate('/design');
  };

  const winners = [
    {
      id: 1,
      month: 'April',
      year: '2025',
      designer: 'Trevor Volpe',
      pattern: 'Leafy Green',
      image: april2025
    },
    {
      id: 2,
      month: 'May',
      year: '2025',
      designer: 'Trevor Volpe',
      pattern: 'Sea of Green',
      image: may2025
    },
    {
      id: 3,
      month: 'June',
      year: '2025',
      designer: 'Trevor Volpe',
      pattern: 'Mesquite Forest',
      image: june2025
    },
    {
      id: 4,
      month: 'July',
      year: '2025',
      designer: 'Ernesto Duran',
      pattern: 'North Wood',
      image: july2025
    },
    {
      id: 5,
      month: 'August',
      year: '2025',
      designer: 'Raul Reyes',
      pattern: 'Andean',
      image: august2025
    },
    {
      id: 6,
      month: 'September',
      year: '2025',
      designer: 'Humberto Banuelos',
      pattern: 'Petrified Forest',
      image: september2025
    },
    {
      id: 7,
      month: 'October',
      year: '2025',
      designer: 'Trevor Volpe',
      pattern: 'Sandscape',
      image: october2025
    },
    {
      id: 8,
      month: 'November',
      year: '2025',
      designer: 'Anonymous',
      pattern: 'California Hills',
      image: november2025
    },
    {
      id: 9,
      month: 'December',
      year: '2025',
      designer: 'Trevor Volpe',
      pattern: 'Hawaiin Lava',
      image: december2025
    },
    {
      id: 10,
      month: 'January',
      year: '2026',
      designer: 'Ryan Cobourn',
      pattern: 'Sandy Weasel',
      image: january2026
    },
    {
      id: 11,
      month: 'February',
      year: '2026',
      designer: 'Trevor Volpe',
      pattern: 'Fallow Thistle',
      image: february2026
    },
    {
      id: 12,
      month: 'March',
      year: '2026',
      designer: 'Anonymous',
      pattern: 'Crimson Thicket',
      image: march2026
    },
    {
      id: 13,
      month: 'April',
      year: '2026',
      designer: 'Hunter Miley',
      pattern: 'Shadow Marsh',
      image: april2026
    },
    {
      id: 14,
      month: 'May',
      year: '2026',
      designer: 'Gage B',
      pattern: 'Back country burn',
      image: may2026
    },
    {
      id: 15,
      month: 'June',
      year: '2026',
      designer: 'Gianpablo Balbuena (Akan studios)',
      pattern: 'ChamacoMulti',
      image: june2026
    },
    {
      id: 16,
      month: 'July',
      year: '2026',
      designer: 'William Green Northcutt',
      pattern: 'REDNEKTARN',
      image: july2026
    },
    {
      id: 17,
      month: 'August',
      year: '2026',
      designer: 'schuco miniature bear',
      pattern: 'KE Chervil',
      image: august2026
    },
    {
      id: 18,
      month: 'September',
      year: '2026',
      designer: null,
      pattern: null,
      image: null,
      isVoteNow: true
    }
  ];

  const winners2025 = winners.filter((winner) => winner.year === '2025');
  const winners2026 = winners.filter((winner) => winner.year === '2026');

  const renderCard = (winner) => (
    <div
      key={winner.id}
      className={`trophy-card ${winner.isVoteNow ? 'vote-now-card' : ''}`}
      onClick={winner.isVoteNow ? handleVoteNow : undefined}
      style={{ cursor: winner.isVoteNow ? 'pointer' : 'default' }}
    >
      <div className="trophy-image">
        {winner.isVoteNow ? (
          <div className="vote-now-placeholder">
            {leadingDesign?.imageUrl && (
              <img
                src={leadingDesign.imageUrl}
                alt={leadingDesign.name || 'Leading September design'}
                className="vote-now-pattern"
              />
            )}
            <span className="vote-now-text">VOTE NOW</span>
          </div>
        ) : (
          <img src={winner.image} alt={`${winner.month} ${winner.year} winner`} />
        )}
      </div>
      <div className="trophy-info">
        <span className="trophy-date">{winner.month} {winner.year}</span>
        {winner.isVoteNow ? (
          leadingDesign && (
            <>
              <span className="trophy-pattern">{leadingDesign.name || 'Untitled'}</span>
              <span className="trophy-designer">{leadingDesign.designerName || 'Anonymous'}</span>
            </>
          )
        ) : (
          <>
            <span className="trophy-pattern">{winner.pattern}</span>
            <span className="trophy-designer">{winner.designer}</span>
          </>
        )}
      </div>
    </div>
  );

  return (
    <section className="trophy-club">
      <div className="trophy-club-content">
        <h2>Trophy Club</h2>
        <p>Celebrating our past winners and their innovative designs</p>

        <div className="trophy-collapse">
          <button
            type="button"
            className="trophy-toggle"
            onClick={() => setShow2025((prev) => !prev)}
            aria-expanded={show2025}
          >
            {show2025 ? 'Hide 2025 Winners' : 'Show 2025 Winners'}
          </button>

          {show2025 && (
            <div className="trophy-grid trophy-grid-2025">
              {winners2025.map(renderCard)}
            </div>
          )}
        </div>

        <div className="trophy-grid">
          {winners2026.map(renderCard)}
        </div>
      </div>
    </section>
  );
};

export default TrophyClub;
